import React, { useEffect, useState } from "react";
import Header from "../common/header/header";
import { Spinner, Tab, Tabs } from "react-bootstrap";
import userservice from "../../services/userservice";
import AdminSideMenu from "../common/adminSideMenu/adminSideMenu";
import "../adduser/css/addUser.css";
import ManageAddUser from "../common/manage/manageAddUser";
import Footer from "../common/footer/footer";

export default function AddUser() {
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState("Manage Role");
  const [currentRole, setCurrentRole] = useState("");

  const handleClick = async (id, name) => {
    setTitle(name);
    setLoading(true);
    const resp = await userservice.getCurrentRole(id);
    setCurrentRole(resp);
    setLoading(false);
  };

  const Init = async () => {
    setLoading(false);
  };

  useEffect(() => {
    Init();
  }, []);

  return (
    <>
      <Header title={"Add Users"} />
      <div className="container-fluid">
        <div className="row">
          <AdminSideMenu handleClick={handleClick} />
          <div className="pt-3 col-xl-10 ">
            <Tabs
              defaultActiveKey="all"
              transition={false}
              id="noanim-tab-example"
              className="mb-3"
              style={{ fontSize: "14px" }}
            >
              <Tab eventKey="all" title={title} className="text-capitalize">
                {loading ? (
                  <center>
                    <Spinner animation="border" />
                  </center>
                ) : !currentRole ? (
                  <div className=" h-25 w-25 p-4 mx-auto">
                    <h5 className="text-danger text-center">
                      Please Select User
                    </h5>
                  </div>
                ) : (
                  <div className="row row-cols-1 row-cols-md-3 g-4">
                    <ManageAddUser id={currentRole._id} />
                  </div>
                )}
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
